import _ from 'lodash';
import { preload, goto } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchUnboxingPage } from 'app/api/onboarding-api';
import Unboxing from 'app/components/setup/unboxing';
import features from 'app/common/containers/features';

const { getStringsForPage, getSectionForPageByIdAndType } = contentfulModels;

const mapStateToProps = (state, ownProps) => {
  const unboxingUpdateEnabled = _.get(state.common, 'features').UNBOXING_UPDATE_ENABLED;

  const { slug } = ownProps.params;
  let articleId = 'unboxing-instructions';
  if (unboxingUpdateEnabled) {
    if (!slug) {
      articleId = 'lets-get-started';
    } else {
      articleId = slug;
    }
  }

  const articleList = _.get(state, 'onboarding.unboxingPage')
    .sections.filter((section) => {
      const { fields: { id } } = section;
      return !(id === 'unboxing-instructions' || id === 'lets-get-started');
    });

  return {
    title: _.get(state, 'onboarding.unboxingPage.title'),
    pageStrings: getStringsForPage(_.get(state, 'onboarding.unboxingPage')),
    articleList,
    unboxingArticle: {
      // Backwards compat with article common components.
      fields: getSectionForPageByIdAndType(
        _.get(state, 'onboarding.unboxingPage'), articleId, 'supportArticle',
      ),
    },
    nextUrl: `${_.get(state.common, 'features').GFCORE_SITE_URL}/setup/`,
  };
};

const mapDispatchToProps = dispatch => ({
  goTo: (slug) => {
    if (!slug) {
      dispatch(goto('/setup/unboxing'));
      return;
    }
    dispatch(goto(`/setup/unboxing/${slug}`));
  },
});

const preloadContent = ({ dispatch }) =>
  Promise.all([
    dispatch(fetchUnboxingPage()),
  ]);

const UnboxingContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(preload(preloadContent)(Unboxing));

export default features(UnboxingContainer);



// WEBPACK FOOTER //
// ./app/containers/setup/unboxing.js